// 월 기준 병합: next 에 있는 달은 next 값으로 교체(이중집계 방지),
// prev 에만 있는 달은 유지. 결과는 월 오름차순 정렬.
export function mergeByMonth<T extends { month: string }>(prev: T[], next: T[]): T[] {
  const nextMonths = new Set(next.map(r => r.month));
  return [...prev.filter(r => !nextMonths.has(r.month)), ...next]
    .sort((a, b) => a.month.localeCompare(b.month));
}
